import { useState } from 'react';
import './Presentation.css';
import { PRESENTATION, PRESENTATION_BASE } from './presentationConfig';
import { PasscodeGate, isUnlocked, isViewerUnlocked, VIEWER_UNLOCK_KEY } from './modes/PasscodeGate';
import PreviewMode from './modes/PreviewMode';
import PresenterMode from './modes/PresenterMode';
import PresenterRemote from './modes/PresenterRemote';
import ViewerMode from './modes/ViewerMode';

export { PRESENTATION_BASE };

// Standalone, auth-free route. Sub-paths: /preview (default) · /present · /presenter · /watch (approver link)
export default function JacksonStopsPresentation() {
  const sub = window.location.pathname.replace(/\/+$/, '').split('/')[2] || 'preview';
  const [unlocked, setUnlocked] = useState(() => (sub === 'watch' ? isViewerUnlocked() : isUnlocked()));
  if (sub === 'watch') {
    if (!unlocked) {
      return (
        <PasscodeGate
          onUnlock={() => setUnlocked(true)}
          passcode={PRESENTATION.viewerPasscode}
          storageKey={VIEWER_UNLOCK_KEY}
          storage="session"
          subtitle="Enter the passcode you were sent and the presentation will play."
          cta="Play presentation"
        />
      );
    }
    return <ViewerMode />;
  }
  if (!unlocked) return <PasscodeGate onUnlock={() => setUnlocked(true)} />;
  if (sub === 'present') return <PresenterMode />;
  if (sub === 'presenter') return <PresenterRemote />;
  return <PreviewMode />;
}
